import { Injectable, inject } from '@angular/core';
import {
  ProjectSurveyTaskServiceAllowedTaskOptionsRequest,
  ProjectSurveyTaskServiceCreateRequest,
  ProjectSurveyTaskServiceCreateResponse,
  ProjectSurveyTaskServiceCreateResponseSchema,
  ProjectSurveyTaskServiceGetResponseSchema,
  ProjectSurveyTaskServiceListRequest,
  ProjectSurveyTaskServiceUpdateRequest,
  ProjectSurveyTaskServiceUpdateResponseSchema,
} from '@vmspdb/definitions';
import { ConnectProjectSurveyTask } from '@vmspdb/ui/connect';
import { ApiPaginated } from '@vmspdb/ui/domain';
import { Observable, map } from 'rxjs';
import { ApiRepositoryService } from './api-repository.service';
import { reencode } from './reencode';

@Injectable({
  providedIn: 'root',
})
export class SurveyTaskRepositoryService implements ApiRepositoryService<
  ProjectSurveyTaskServiceCreateRequest,
  ProjectSurveyTaskServiceUpdateRequest,
  ProjectSurveyTaskServiceListRequest,
  ProjectSurveyTaskServiceCreateResponse
> {
  private api = inject(ConnectProjectSurveyTask);

  create(
    data: ProjectSurveyTaskServiceCreateRequest,
  ): Observable<ProjectSurveyTaskServiceCreateResponse> {
    return this.api.create(data).pipe();
  }

  delete(uuid: string): Observable<void> {
    return this.api.delete({ uuid }).pipe(
      map(() => {
        return;
      }),
    );
  }

  fetch(uuid: string): Observable<ProjectSurveyTaskServiceCreateResponse> {
    return this.api
      .get({ uuid })
      .pipe(
        map((res) =>
          reencode(
            ProjectSurveyTaskServiceGetResponseSchema,
            ProjectSurveyTaskServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  list(
    request: ProjectSurveyTaskServiceListRequest,
  ): Observable<ApiPaginated<ProjectSurveyTaskServiceCreateResponse>> {
    return this.api.list(request);
  }

  update(
    data: ProjectSurveyTaskServiceUpdateRequest,
  ): Observable<ProjectSurveyTaskServiceCreateResponse> {
    return this.api
      .update(data)
      .pipe(
        map((res) =>
          reencode(
            ProjectSurveyTaskServiceUpdateResponseSchema,
            ProjectSurveyTaskServiceCreateResponseSchema,
            res,
          ),
        ),
      );
  }

  allowedTaskOptions(
    request: ProjectSurveyTaskServiceAllowedTaskOptionsRequest,
  ) {
    return this.api.allowedTaskOptions(request).pipe(
      map(({ options }) =>
        options.map((option) => ({
          ...option,
          value: option.optionValue,
        })),
      ),
    );
  }
}
